// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1Cg17","inputWrap":"styles_inputWrap__f7qlZ","input":"styles_input__3ZY0D"};